import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PATH } from '../../constants/path.constant';
import { ROLE } from '../../constants/roles.constant';
import { getToken } from '../../utils/auth';

// Routes that are also reachable by LMS students via a short-lived
// JWT minted by uniapp-backend `/elearning/my/request-cabin-booking`.
// When the URL carries `?lms_token=...`, skip the teacher-role check
// — the page itself (e.g. CalcomPage) verifies the token through the
// BE before unlocking any UI, and falls back to this guard if the
// JWT is missing or invalid.
const STUDENT_MODE_PATHS = new Set(['/cabin']);

function TeacherGuard({ children }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  if (STUDENT_MODE_PATHS.has(location.pathname) && params.get('lms_token')) {
    return children;
  }

  const token = getToken();
  const userInfo = (() => {
    try { return JSON.parse(localStorage.getItem('user-info')); } catch (_) { return null; }
  })();
  const role = Array.isArray(userInfo?.role) ? userInfo.role : [];

  const allowed =
    role.includes(ROLE.ADMIN) ||
    role.includes(ROLE.DRIVING.ADMIN) ||
    role.includes(ROLE.DRIVING.DAT_ADMIN) ||
    role.includes(ROLE.DRIVING.TEACHER) ||
    role.includes(ROLE.DRIVING.REPORTER) ||
    // DAT_TEACHER (16): dat-only role — TeacherGuard allows it, but
    // AdminGuard / AdminDrivingGuard intentionally do NOT, so the
    // account can browse cabin/search/dat but can't open admin
    // pages here or in uniapp-frontend (driving/admin/*).
    role.includes(ROLE.DRIVING.DAT_TEACHER);

  if (token && allowed) return children;

  return (
    <Navigate
      to={PATH.ADMIN.LOGIN}
      state={{ from: location.pathname + location.search }}
      replace
    />
  );
}

export default TeacherGuard;
